export const initialState = Object.freeze({
  gettingStarted: {
    reasons: [],
    rooms: [],
    services: [],
    family: {
      adults: {},
      children: {},
      pets: {},
    },
    address: {},
    proPlatform: false,
  },
  gettingStartedPlan: {
    rooms: [],
    prices: {},
    packages: {},
    packagesOptions: [],
    plansOptions: [],
    address: {
      address: undefined,
      town: undefined,
      postcode: undefined,
      phone: undefined,
    },
  },
});

export default (state, action) => {
  switch (action.type) {
    case 'gettingStarted/update':
      return {
        ...state,
        gettingStarted: {
          ...state.gettingStarted,
          ...action.payload,
          family: {
            ...state.gettingStarted.family,
            ...(action.payload.family || {}),
          },
        },
      };
    case 'gettingStartedPlan/update':
      return {
        ...state,
        gettingStartedPlan: {
          ...state.gettingStartedPlan,
          ...action.payload,
          packages: action.payload.packages || state.gettingStartedPlan.packages || {},
        },
      };
    default:
      throw new Error();
  }
};



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/store/reducer.js